import { render, staticRenderFns } from "./DoKoHome.vue?vue&type=template&id=4cf295ad&"
import script from "./DoKoHome.vue?vue&type=script&lang=ts&"
export * from "./DoKoHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports